import { useEffect, useState } from 'react';

export function useHeightContent(idArr: any[], height: any) {
    const [heightContent, setHeightContent] = useState(0);

    useEffect(() => {
        if (height) {
            idArr.forEach((element) => {
                const temp: any = document.getElementById(`${element}`)?.offsetHeight;
                setHeightContent(height - temp);
            });
        }
    }, [height, idArr]);
    return heightContent;
}
